const Footer = () => {
  return (
    <div className="flex justify-center items-center">
      <div className="w-11/12 h-auto">
        <div className="flex flex-col justify-center items-center">
          <p className="font-mono text-sm text-blueEdit pt-3">
            Designed & built by Frederick Boyd
          </p>
          <p className="font-mono text-sm text-blueEdit pt-2 pb-24 sm:pb-8">
            ©2025 present , All rights reserved
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
